import Api from './api';

const shippingGroupsListRequest = (userId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/shippingGroups/' + userId, {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const createShippingGroupRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/shippingGroups/', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const updateShippingGroupRequest = (id, data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().put('/api/shippingGroup/' + id, data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const deleteShippingGroupRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/shippingGroup/' + id, { headers:
        {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }

    })
}


export default { shippingGroupsListRequest, createShippingGroupRequest, deleteShippingGroupRequest, updateShippingGroupRequest }



// WEBPACK FOOTER //
// ./src/api/apiShippingGroups.js